import { useTranslation } from 'react-i18next';
import { PremiumBackground } from './PremiumBackground';
import { OnboardingThemePicker } from './OnboardingThemePicker';
import type { OnboardingSlideMeta } from '../../constants/onboarding';

interface DesktopOnboardingProps {
  slide: number;
  total: number;
  current: OnboardingSlideMeta;
  isLast: boolean;
  onNext: () => void;
  onSkip: () => void;
}

export function DesktopOnboarding({
  slide,
  total,
  current,
  isLast,
  onNext,
  onSkip,
}: DesktopOnboardingProps) {
  const { t } = useTranslation();
  const isContain = current.illustrationFit === 'contain';

  return (
    <div className="cs-premium-desktop cs-premium-desktop--onboarding">
      <PremiumBackground subtle />

      <div className="cs-premium-desktop__shell">
        <section className="cs-premium-desktop__panel">
          <div className="cs-premium-desktop__brand">
            <span className="cs-premium-desktop__brand-mark" aria-hidden>
              <img src="/brand/logo-64.webp" alt="" width={28} height={28} draggable={false} />
            </span>
            <span className="cs-premium-desktop__brand-name">CozzySIM</span>
          </div>

          <div className="cs-premium-desktop__copy">
            <p className="cs-premium-desktop__eyebrow">
              {t('onboarding.step', { current: slide + 1, total })}
            </p>
            <h1 className="cs-premium-desktop__title">{t(current.titleKey)}</h1>
            <p className="cs-premium-desktop__subtitle">{t(current.subtitleKey)}</p>
          </div>

          <div className="cs-premium-desktop__dots" aria-hidden>
            {Array.from({ length: total }, (_, index) => (
              <span
                key={index}
                className={`cs-premium-desktop__dot${
                  index === slide ? ' cs-premium-desktop__dot--active' : ''
                }`}
              />
            ))}
          </div>

          <div className="cs-premium-desktop__actions">
            <button type="button" className="cs-premium-desktop__btn" onClick={onNext}>
              {t(current.ctaKey)}
            </button>
            {!isLast && (
              <button type="button" className="cs-premium-desktop__skip" onClick={onSkip}>
                {t('onboarding.skipTour')}
              </button>
            )}
          </div>
        </section>

        <section className="cs-premium-desktop__visual" key={slide}>
          {current.kind === 'theme' ? (
            <OnboardingThemePicker />
          ) : (
            <div
              className={`cs-premium-desktop__frame${
                isContain ? ' cs-premium-desktop__frame--contain' : ''
              }`}
            >
              <div className="cs-premium-desktop__frame-glow" aria-hidden />
              <img
                src={current.illustration ?? ''}
                alt=""
                className="cs-premium-desktop__frame-image"
                draggable={false}
              />
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
